import { checkNativeGpsEnabled, openNativeGpsSettings, isInNativeWrapper } from '@/services/nativeBridge';

/**
 * Acquisizione GPS condivisa tra i modali selettive. Nel wrapper RN: pre-check
 * hardware GPS, propone Settings se spento (l'utente lo accende e torna in app).
 * In ogni caso tenta navigator.geolocation con timeout 8s.
 */
export async function getGps(): Promise<{ lat: number | null; lng: number | null }> {
  if (isInNativeWrapper()) {
    const enabled = await checkNativeGpsEnabled();
    if (!enabled) {
      const ok = window.confirm(
        'Il GPS del telefono e\' spento.\n\n'
        + 'Per inviare la tua posizione alla selettiva e\' necessario accenderlo.\n\n'
        + 'Apro le impostazioni GPS? (attiva la posizione e torna in app)',
      );
      if (ok) openNativeGpsSettings();
      // Comunque tentiamo di leggere la posizione: se l'utente l'ha appena
      // attivata, navigator.geolocation potrebbe avere successo al volo.
    }
  }
  return new Promise(resolve => {
    if (!navigator.geolocation) return resolve({ lat: null, lng: null });
    navigator.geolocation.getCurrentPosition(
      p => resolve({ lat: p.coords.latitude, lng: p.coords.longitude }),
      () => resolve({ lat: null, lng: null }),
      { enableHighAccuracy: true, timeout: 8000 },
    );
  });
}
